"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Actions = _interopRequireDefault(require("./Actions"));

var _getSchemaValidator = _interopRequireDefault(require("./getSchemaValidator"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var createActions = function createActions(_ref) {
  var namespace = _ref.namespace,
      type = _ref.type,
      _ref$schema = _ref.schema,
      schema = _ref$schema === void 0 ? {} : _ref$schema;
  return (0, _Actions["default"])(namespace, type, (0, _getSchemaValidator["default"])(schema));
};

var _default = createActions;
exports["default"] = _default;